import authType from "./publicRestaurantTypes";

const initialState = {
  isLoading: false,
  loadingMore: false,
  loadingFeedback: false,
  loadingSearch: false,
  allRestaurants: {},
  filter: {},
  restaurant: {},
  search: [],
  restaurantFeedback: {},
};

export default function publicRestaurantReducer(state = initialState, action) {
  switch (action.type) {
    case authType.LOADING_RESTAURANT:
      return {
        ...state,
        isLoading: action.payLoad,
      };

    case authType.LOADING_MORE:
      return {
        ...state,
        loadingMore: action.payLoad,
      };

    case authType.LOADING_FEEDBACK:
      return {
        ...state,
        loadingFeedback: action.payLoad,
      };

    case authType.LOADING_SEARCH:
      return {
        ...state,
        loadingSearch: action.payLoad,
      };

    case authType.ALL_RESTAURANTS:
      return {
        ...state,
        allRestaurants: action.payLoad?.data,
      };

    case authType.MORE_RESTAURANTS:
      return {
        ...state,
        allRestaurants: {
          ...state.allRestaurants,
          data: [...state.allRestaurants.data, ...action.payLoad?.data?.data],
        },
      };

    case authType.SINGLE_RESTAURANT:
      return {
        ...state,
        restaurant: action.payLoad?.data,
      };

    case authType.FILTER_RESTAURANTS:
      return {
        ...state,
        filter: action.payLoad?.data,
        allRestaurants: action.payLoad?.data,
      };

    case authType.SEARCH_RESTAURANT:
      return {
        ...state,
        search: action.payLoad?.data,
      };

    case authType.GET_RESTAURANT_FEEDBACK:
      return {
        ...state,
        restaurantFeedback: action.payLoad?.data,
      };

    default:
      return state;
  }
}
